import 'C:\\Projects\\genkei\\zumeco\\static\\shared\\components\\ToolbarSwitches.tsx.esbuild-plugin-windicss.css';
import { ToolbarSwitch } from './ToolbarSwitch';
export interface ToolbarSwitchesItem<T extends string | number | undefined> {
  readonly value: T;
  readonly children: any;
}
export function ToolbarSwitches<T extends string | number | undefined>({
  name,
  direction,
  columnCount,
  items,
  selectedValue,
  onChange
}: {
  name: string;
  direction?: 'row' | 'column';
  columnCount?: number;
  items: readonly ToolbarSwitchesItem<T>[];
  selectedValue: T | undefined;
  onChange: (value: T) => void;
}) {
  return <div style={columnCount ? {
    display: 'grid',
    gridTemplateColumns: `repeat(${columnCount},max-content)`
  } : {
    display: 'flex',
    flexDirection: direction || 'row'
  }} onChange={event => {
    const radio = event.target as HTMLInputElement;
    if (radio.name === name && radio.checked) {
      onChange((radio.value || undefined) as T);
    }
  }}>
      {items.map(item => <ToolbarSwitch key={item.value} name={name} value={item.value ?? ''} selected={item.value === selectedValue}>
          {item.children}
        </ToolbarSwitch>)}
    </div>;
}